import { LitElement, html, css, unsafeCSS } from 'lit';
import styles from './tabNavigationButton.scss?inline';
import { classMap } from 'lit/directives/class-map.js';

export default class SotbitTabNavButton extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        icon: { type: String },
        href: { type: String },
        badge: { type: Boolean },
        active: { type: Boolean },
        disabled: { type: Boolean },
    };

    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    render() {
        const tabNavBtnClasses = {
            'active': this.active,
            'disabled': this.disabled,
        };

        return this.href
            ? html`
                  <a href="${this.href}" class="tab-nav-btn${classMap(tabNavBtnClasses)}">
                      <div class="tab-nav-btn__icon ${this.badge ? 'tab-nav-btn__icon-badge' : ''}">
                          <sotbit-icon
                              slot="content"
                              icon="${this.icon}${this.active ? '-filled' : ''}"
                              no-padding
                          ></sotbit-icon>
                      </div>
                      <div class="tab-nav-btn__title-wrap">
                          <slot class="tab-nav-btn__title"></slot>
                      </div>
                  </a>
              `
            : html`
                  <button class="tab-nav-btn">
                      <sotbit-icon
                          slot="content"
                          icon="${this.icon}"
                          no-padding
                          class="tab-nav-btn__icon"
                      ></sotbit-icon>
                      <div class="tab-nav-btn__title-wrap">
                          <slot class="tab-nav-btn__title"></slot>
                      </div>
                  </button>
              `;
    }
}
